module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-13.96fd2535.png";